import { type FC, useState } from 'react';
import { Icon, IconType } from '../../Props/Icon/Icon';
import { useClickOutside } from '../../../lib/hooks/useOnClickOutside';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';
import { MenuItem, OptionsMenuContainer, Menu } from './styles/MenuButtonStyles';

export const UserOptionsMenu: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const clickOutsideRef = useClickOutside<HTMLDivElement>(() => setIsMenuOpen(false));

  const onOptionClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <OptionsMenuContainer ref={clickOutsideRef} $isOpen={isMenuOpen}>
      <div onClick={() => setIsMenuOpen((prev) => !prev)}>
        <Icon icon={IconType.DOTS_MENU_ICON} width={16} height={16} />
      </div>
      <Menu $isHidden={!isMenuOpen} $placement="bottom-end">
        <MenuItem onClick={onOptionClick}>
          <NamedContentEntryText refKey="managerTeamMembers" container="span" subKey="flagAsNotPartOfTeam" />
        </MenuItem>
        <MenuItem onClick={onOptionClick}>
          <NamedContentEntryText refKey="managerTeamMembers" container="span" subKey="viewAsTeamMembers" />
        </MenuItem>
      </Menu>
    </OptionsMenuContainer>
  );
};
